// extracted by mini-css-extract-plugin
module.exports = {"details":"unT_jBnq-zcl7tqo32vz_","details__info-panel":"_1ftsu0FdF989l79QvbfRnn","details__spec-container":"J5WNKlYK5uG--B4KWM9LC"};